"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var ActiveChartPeriod_1 = __importDefault(require("./styledComponents/ActiveChartPeriod"));
var ChartPeriod_1 = __importDefault(require("./ChartPeriod"));
var DisabledChartPeriod_1 = __importDefault(require("./styledComponents/DisabledChartPeriod"));
var Translate_1 = __importDefault(require("../../base/Translate/Translate"));
var ChartPeriodSelection_meta_1 = require("./ChartPeriodSelection.meta");
var mobx_1 = require("mobx");
exports.NAVIGATION_KEYS = [
    shared_1.KEYS.LEFT_ARROW,
    shared_1.KEYS.RIGHT_ARROW,
    shared_1.KEYS.HOME,
    shared_1.KEYS.END,
];
var ChartPeriodSelection = /** @class */ (function (_super) {
    __extends(ChartPeriodSelection, _super);
    function ChartPeriodSelection(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = ChartPeriodSelection_meta_1.CHART_PERIOD_SELECTION_CATEGORY_KEY;
        _this.componentKey = ChartPeriodSelection_meta_1.CHART_PERIOD_SELECTION_COMPONENT_KEY;
        _this.periodId = "period_" + ksys_app_template_1.utils.guid.generateGuid();
        _this.focusedIndex = null;
        _this.selectedPeriod = 'ALL';
        _this.initialPeriod = 'ALL';
        _this.setCurrentDates = function (currentStartDate, currentEndDate) {
            if (!currentStartDate || !currentEndDate) {
                _this.currentStartDate = undefined;
                _this.currentEndDate = undefined;
            }
            else {
                _this.currentStartDate = currentStartDate;
                _this.currentEndDate = currentEndDate;
                // Set the selected period
                var monthsDiff = _this.getDateDifferenceInMonths(_this.currentStartDate, _this.currentEndDate);
                var ytdDifference = _this.ytdDifference;
                _this.selectedPeriod = undefined;
                if (_this.props.endDate === _this.currentEndDate) {
                    if (_this.props.startDate === _this.currentStartDate) {
                        _this.selectedPeriod = 'ALL';
                    }
                    else {
                        var periods = _this.props.periods;
                        if (periods) {
                            var displayPeriods = Object.keys(periods);
                            for (var _i = 0, displayPeriods_1 = displayPeriods; _i < displayPeriods_1.length; _i++) {
                                var period = displayPeriods_1[_i];
                                if (period !== 'ALL' && period !== 'YTD') {
                                    if (_this.isWeekPeriod(period)) {
                                        var periodInWeeks = _this.getDurationFromPeriod(period);
                                        var weekDiff = _this.getDateDifferenceInWeeks(_this.currentStartDate, _this.currentEndDate);
                                        if (periodInWeeks === weekDiff) {
                                            _this.selectedPeriod = period;
                                            break;
                                        }
                                    }
                                    else {
                                        var periodInMonths = _this.getPeriodMonths(period);
                                        if (periodInMonths === monthsDiff) {
                                            _this.selectedPeriod = period;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (!_this.selectedPeriod && monthsDiff === ytdDifference) {
                        _this.selectedPeriod = 'YTD';
                    }
                }
            }
        };
        _this.setDefaultPeriod = function (defaultPeriod) {
            _this.initialPeriod = defaultPeriod;
            _this.selectedPeriod = defaultPeriod;
            _this.handleClick(defaultPeriod, false);
        };
        _this.handleClick = function (period, logDataLayer, index) {
            if (logDataLayer === void 0) { logDataLayer = true; }
            var _a = _this.props, startDate = _a.startDate, onClick = _a.onClick, analyticsContext = _a.analyticsContext, suppressAnalytics = _a.suppressAnalytics;
            if (onClick) {
                var newStartDate = _this.getNewStartDate(period);
                var dateString = newStartDate.toJSON();
                var response = {
                    logDataLayer: logDataLayer,
                    origStartDate: startDate || '',
                    selectedStartDate: dateString.slice(0, dateString.indexOf('T')),
                    timestamp: newStartDate.valueOf(),
                    selectedPeriodLabel: period,
                };
                onClick(response);
                _this.selectedPeriod = period;
                _this.currentEndDate = _this.props.endDate;
                _this.currentStartDate = response.selectedStartDate;
                if (_this.analyticsHelper && !suppressAnalytics) {
                    var periodDefaultAnalytics = {
                        period: _this.selectedPeriod,
                        startDate: _this.currentStartDate,
                        endDate: _this.currentEndDate ? _this.currentEndDate.replace(/T\d.*$/, '') : undefined,
                    };
                    if (analyticsContext) {
                        periodDefaultAnalytics = __assign(__assign({}, periodDefaultAnalytics), analyticsContext);
                    }
                    _this.analyticsHelper.logEvent({
                        event: 'button_click',
                        eventType: 'click',
                        context: periodDefaultAnalytics,
                    });
                }
                if (!ksys_app_template_1.utils.typeChecks.isNullOrUndefined(index)) {
                    _this.focusedIndex = index;
                }
            }
        };
        _this.handleKeyDown = function (e) {
            var key = e.key;
            if (exports.NAVIGATION_KEYS.indexOf(key) !== -1) {
                e.preventDefault();
                e.stopPropagation();
                _this.onNavigation(key);
            }
        };
        _this.setDefaultPeriod(props.defaultPeriod);
        if (props.shouldCalculateSelectedPeriod) {
            _this.setCurrentDates(props.currentStartDate, props.currentEndDate);
        }
        return _this;
    }
    Object.defineProperty(ChartPeriodSelection.prototype, "isLeapDay", {
        get: function () {
            var endDate = this.props.endDate;
            if (endDate) {
                var date = new Date(endDate);
                return date.getMonth() === 1 && date.getDate() === 29;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    ChartPeriodSelection.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, defaultPeriod = _a.defaultPeriod, currentStartDate = _a.currentStartDate, currentEndDate = _a.currentEndDate, _b = _a.shouldCalculateSelectedPeriod, shouldCalculateSelectedPeriod = _b === void 0 ? false : _b;
        if (this.initialPeriod !== defaultPeriod) {
            this.setDefaultPeriod(defaultPeriod);
        }
        if (shouldCalculateSelectedPeriod) {
            if (prevProps.currentStartDate !== currentStartDate || prevProps.currentEndDate !== currentEndDate) {
                this.setCurrentDates(currentStartDate, currentEndDate);
            }
        }
    };
    ChartPeriodSelection.prototype.getDurationFromPeriod = function (item) {
        return Number(item.slice(0, item.length - 1));
    };
    ChartPeriodSelection.prototype.getDurationUnitFromPeriod = function (item) {
        return item.slice(-1).toLowerCase();
    };
    ChartPeriodSelection.prototype.getPeriodLabel = function (item) {
        var periods = this.props.periods;
        return react_1.default.createElement(Translate_1.default, null, periods && periods[item] ? periods[item] : item);
    };
    ChartPeriodSelection.prototype.getPeriodMonths = function (item) {
        var durationUnit = this.getDurationUnitFromPeriod(item);
        var year = durationUnit === 'y';
        var period = this.getDurationFromPeriod(item);
        if (year) {
            period *= 12;
        }
        return period;
    };
    ChartPeriodSelection.prototype.isWeekPeriod = function (item) {
        return this.getDurationUnitFromPeriod(item) === 'w';
    };
    ChartPeriodSelection.prototype.isPeriodDisabled = function (item, monthDifference, weekDifference) {
        if (this.isWeekPeriod(item)) {
            var weekDuration = this.getDurationFromPeriod(item);
            return weekDifference < weekDuration;
        }
        if (item !== 'ALL' && item !== 'YTD') {
            var period = this.getPeriodMonths(item);
            return monthDifference < period;
        }
        if (item === 'YTD') {
            return this.ytdDifference < 0;
        }
        return false;
    };
    ChartPeriodSelection.prototype.getStartDateByWeeks = function (item, endDate) {
        var weekDuration = this.getDurationFromPeriod(item) * 7;
        return new Date(endDate.setDate(endDate.getDate() - weekDuration));
    };
    Object.defineProperty(ChartPeriodSelection.prototype, "ytdDifference", {
        get: function () {
            var endDate = this.props.endDate;
            if (endDate) {
                var date = new Date(endDate);
                // last day of previous year
                var newStartDate = (date.getFullYear() - 1) + "-12-31";
                return this.getDateDifferenceInMonths(newStartDate, endDate);
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    ChartPeriodSelection.prototype.getDateDifferenceInMonths = function (startDate, endDate) {
        return ksys_app_template_1.utils.date.getDateDifference(new Date(endDate), new Date(startDate), 'MONTHS');
    };
    ChartPeriodSelection.prototype.getDateDifferenceInWeeks = function (startDate, endDate) {
        return ksys_app_template_1.utils.date.getDateDifference(new Date(endDate), new Date(startDate), 'WEEKS');
    };
    ChartPeriodSelection.prototype.getNewStartDate = function (period) {
        var _a = this.props, startDate = _a.startDate, endDate = _a.endDate;
        if (startDate && endDate) {
            if (period === 'ALL') {
                return new Date(startDate);
            }
            var newDate = new Date(endDate);
            if (this.isWeekPeriod(period)) {
                return this.getStartDateByWeeks(period, newDate);
            }
            var months = period === 'YTD' ? this.ytdDifference : this.getPeriodMonths(period);
            newDate.setUTCMonth(newDate.getUTCMonth() - months);
            if (this.isLeapDay && months % 12 === 0) {
                newDate.setUTCDate(newDate.getUTCDate() - 1);
            }
            return newDate;
        }
        return new Date();
    };
    ChartPeriodSelection.prototype.isPeriodSelected = function (period) {
        return this.selectedPeriod === period;
    };
    ChartPeriodSelection.prototype.onNavigation = function (key) {
        // Get current focused element, in case tab moved the focus
        var currentFocusedElement = document.activeElement;
        if (currentFocusedElement) {
            var currentFocusedID = currentFocusedElement.id.split('_');
            var currFocusedIndex = Number(currentFocusedID[currentFocusedID.length - 1]);
            // Dont set the focusedIndex if it is current
            if (this.focusedIndex !== currFocusedIndex) {
                this.focusedIndex = currFocusedIndex;
            }
        }
        else {
            // This should never occur as this component elements would trigger this
            // the onclick will set the focus else tab would have moved the focus onto a period
            this.focusedIndex = 0;
        }
        if (this.periods) {
            switch (key) {
                case shared_1.KEYS.LEFT_ARROW:
                    if (this.focusedIndex === 0) {
                        this.focusedIndex = this.periods.length - 1;
                    }
                    else {
                        this.focusedIndex = this.focusedIndex - 1;
                        while (this.periods[this.focusedIndex].props.disabled === true && this.focusedIndex !== 0) {
                            this.focusedIndex--;
                        }
                    }
                    break;
                case shared_1.KEYS.RIGHT_ARROW:
                    this.focusedIndex = (this.focusedIndex + 1) % this.periods.length;
                    while (this.periods[this.focusedIndex].props.disabled === true && this.focusedIndex <= this.periods.length) {
                        this.focusedIndex++;
                    }
                    break;
                case shared_1.KEYS.HOME:
                    this.focusedIndex = 0;
                    break;
                case shared_1.KEYS.END:
                    this.focusedIndex = this.periods.length - 1;
                    break;
                default:
                    break;
            }
        }
    };
    Object.defineProperty(ChartPeriodSelection.prototype, "periods", {
        get: function () {
            var _this = this;
            var _a = this.props, periods = _a.periods, startDate = _a.startDate, endDate = _a.endDate;
            if (periods && startDate && endDate) {
                var displayPeriods = Object.keys(periods);
                var monthDifference_1 = this.getDateDifferenceInMonths(startDate, endDate);
                var weekDifference_1 = this.getDateDifferenceInWeeks(startDate, endDate);
                if (!displayPeriods || startDate > endDate) {
                    return null;
                }
                return (displayPeriods.map(function (period, index) {
                    var periodHasNoData = _this.isPeriodDisabled(period, monthDifference_1, weekDifference_1);
                    if (periodHasNoData && period !== 'ALL' && _this.isPeriodSelected(period) && (!_this.currentStartDate && !_this.currentEndDate)) {
                        _this.selectedPeriod = 'ALL';
                    }
                    var onClick = !periodHasNoData ? function () { return _this.handleClick(period, true, index); } : function () { };
                    var periodId = _this.periodId + "_button_" + index;
                    var periodProps = {
                        onClick: onClick,
                        id: periodId,
                        onKeyDown: function (e) { return _this.handleKeyDown(e); },
                        focused: !periodHasNoData && _this.focusedIndex === index,
                    };
                    var PeriodComponent;
                    if (periodHasNoData) {
                        PeriodComponent = DisabledChartPeriod_1.default;
                        periodProps.disabled = true;
                    }
                    else if (_this.isPeriodSelected(period)) {
                        PeriodComponent = ActiveChartPeriod_1.default;
                        periodProps.active = true;
                    }
                    else {
                        PeriodComponent = ChartPeriod_1.default;
                    }
                    return (react_1.default.createElement(PeriodComponent, __assign({ key: periodId }, periodProps), _this.getPeriodLabel(period)));
                }));
            }
        },
        enumerable: true,
        configurable: true
    });
    ChartPeriodSelection.prototype.render = function () {
        var _this = this;
        var className = this.props.className;
        /**
         * Why is this here?
         *
         * The state management within Mobx is triggering a delayed render, so when we change a date in a date picker,
         * the chart period selection component is only rendering the previous update. By referencing the this.selectedPeriod
         * within the render, React can see that the observable has changed and triggers the correct rerender.
         */
        this.selectedPeriod;
        return (react_1.default.createElement(shared_1.AnalyticsContext.Consumer, null, function (analyticsHelper) {
            _this.analyticsHelper = analyticsHelper;
            return (react_1.default.createElement(Wrapper_1.default, { className: className }, _this.periods));
        }));
    };
    __decorate([
        mobx_1.observable.ref
    ], ChartPeriodSelection.prototype, "focusedIndex", void 0);
    __decorate([
        mobx_1.observable
    ], ChartPeriodSelection.prototype, "selectedPeriod", void 0);
    __decorate([
        mobx_1.observable
    ], ChartPeriodSelection.prototype, "initialPeriod", void 0);
    __decorate([
        mobx_1.observable
    ], ChartPeriodSelection.prototype, "currentStartDate", void 0);
    __decorate([
        mobx_1.observable
    ], ChartPeriodSelection.prototype, "currentEndDate", void 0);
    __decorate([
        mobx_1.computed
    ], ChartPeriodSelection.prototype, "isLeapDay", null);
    __decorate([
        mobx_1.action
    ], ChartPeriodSelection.prototype, "setCurrentDates", void 0);
    __decorate([
        mobx_1.action
    ], ChartPeriodSelection.prototype, "setDefaultPeriod", void 0);
    __decorate([
        mobx_1.computed
    ], ChartPeriodSelection.prototype, "ytdDifference", null);
    __decorate([
        mobx_1.action
    ], ChartPeriodSelection.prototype, "handleClick", void 0);
    __decorate([
        mobx_1.computed
    ], ChartPeriodSelection.prototype, "periods", null);
    ChartPeriodSelection = __decorate([
        mobx_react_1.observer
    ], ChartPeriodSelection);
    return ChartPeriodSelection;
}(shared_1.ComponentBase));
exports.ChartPeriodSelection = ChartPeriodSelection;
exports.default = shared_1.InjectedStyledComponent(ChartPeriodSelection, ChartPeriodSelection_meta_1.CHART_PERIOD_SELECTION_CATEGORY_KEY, ChartPeriodSelection_meta_1.CHART_PERIOD_SELECTION_COMPONENT_KEY);
